import React from "react";

const withLazyLoad = (importFunc: () => Promise<{ default: React.ComponentType<any> }>) => {
  const LazyComponent = React.lazy(importFunc);

  return (props: Record<string, any>) => (
    <React.Suspense
      fallback={
        <div
          className="loader-container"
          style={{ userSelect: "none", WebkitUserSelect: "none", msUserSelect: "none" }}
        >
          <div className="loader-base">
            <div className="lds-ripple">
              <img src="/images/loader.svg" />
            </div>
          </div>
        </div>
      }
    >
      <LazyComponent {...props} />
    </React.Suspense>
  );
};

export default withLazyLoad;
